import { UserBusinessEntityCountryCode } from 'types/User';

/**
 * check if the user belongs to APAC business entity or not
 * @param countryCode number
 */
export const isApacBusinessEntity = (countryCode: number) => {
  return UserBusinessEntityCountryCode.SG === countryCode || UserBusinessEntityCountryCode.HK === countryCode;
};
